<template>
  <div class="add-filter position-relative">
    <v-btn
      variant="text"
      block
      height="45"
      class="justify-start"
      prepend-icon="mdi-plus"
      v-bind="$attrs"
      @click="showDropdown = true"
    >
      Add Filter
    </v-btn>
    <FilterGroups
      v-if="showDropdown"
      :filter-groups="filterGroups"
      class="filter-options position-absolute overflow-y-scroll"
      @add-new-filter="addNewFilter"
      @close-options="showDropdown = false"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import FilterGroups from './FilterGroups.vue';

export default defineComponent({
  name: 'AddFilterButton',
  components: {
    FilterGroups,
  },
  inheritAttrs: false,
  props: {
    filterGroups: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-new-filter'],
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    addNewFilter(label: string, groupLabel: string) {
      this.showDropdown = false;
      this.$emit('add-new-filter', label, groupLabel);
    },
  },
});
</script>

<style scoped lang="scss">
.add-filter {
  height: 45px;
}

.filter-options {
  right: 57px;
  max-height: 450px;
}
</style>
